import { render, staticRenderFns } from "./SystemFlagsAppeal.vue?vue&type=template&id=0dc746ad&scoped=true&"
import script from "./SystemFlagsAppeal.vue?vue&type=script&lang=js&"
export * from "./SystemFlagsAppeal.vue?vue&type=script&lang=js&"
import style0 from "./SystemFlagsAppeal.vue?vue&type=style&index=0&id=0dc746ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc746ad",
  null
  
)

export default component.exports